export enum EBackgroundColors {
  black = 'black',
  gray_900 = 'gray-900',
  gray_700 = 'gray-700',
  gray_500 = 'gray-500',
  white = 'white',
  danger_main = 'danger-main',
  warning_dark = 'warning-dark',
  warning_light = 'warning-light',
  success_light = 'success-light',
  success_main = 'success-main',
  success_dark = 'success-dark',
  info_main = 'info-main',
  link = 'link',
  link_hover = 'link-hover',
  alternate_light = 'alternate-light',
  transparent = 'transparent',
}

export interface IBackgroundColor {
  backgroundColor?: EBackgroundColors
}
